var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0273 5.63247C8.84131 3.57438 2.78185 1.24949 0.025377 0.34431C-0.549888 17.1521 8.79816 25.7847 13.5441 28C25.337 21.6542 28.0935 7.72869 27.9976 1.55916C27.8538 -0.370306 20.0644 -0.155153 17.4271 0.34431C14.9569 0.812133 10.8356 2.17849 8.79816 2.63108L12.3936 4.84639C18.3188 1.81642 23.3955 2.10703 25.1932 2.63108C26.8615 12.5214 18.1222 21.759 13.5441 25.1415C5.89307 21.0253 2.73391 9.3723 2.11071 4.06032H3.26124C4.35424 4.23182 4.86719 6.41855 4.98703 7.49048L6.56901 4.84639C7.2018 4.50338 7.88733 4.98932 8.15099 5.27516C5.38972 15.5656 13.1846 15.7086 17.4271 14.4937C13.2277 18.6099 7.91129 14.6843 5.77802 12.2069C11.8758 22.4974 19.8466 18.2488 22.5072 14.7471C21.6443 15.3903 19.7282 16.5423 18.6496 16.7805C20.9506 15.9801 22.2929 13.398 22.6764 12.2069C18.6496 14.4937 16.0609 11.2541 14.4789 8.63386C13.0983 9.09122 12.5134 12.4452 12.3936 14.0649C10.8403 13.3789 10.8356 8.15745 11.0273 5.63247Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.030dad00.svg";
export { ForwardRef as ReactComponent };